import { render, staticRenderFns } from "./Step2ConfirmCode.vue?vue&type=template&id=b6e62a3e&scoped=true"
import script from "./Step2ConfirmCode.vue?vue&type=script&lang=js"
export * from "./Step2ConfirmCode.vue?vue&type=script&lang=js"
import style0 from "./Step2ConfirmCode.vue?vue&type=style&index=0&id=b6e62a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e62a3e",
  null
  
)

export default component.exports